<script>
  export let cell;
</script>

<div>
  {#if cell && cell.value && cell.value.length >= 1}
    {#each cell.value.slice(0, -1) as value}
      {value.name + ", "}
    {/each}
    {cell.value[cell.value.length - 1].name}
  {:else}
    --
  {/if}
</div>

<style>
  div {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
  }
</style>
